import config from '../../../config';

const apiV1Url = config.apiUrl();
const baseUrl = `${apiV1Url}/BackOffice/WelcomeEmail`;

export default {
  baseUrl: (): string => `${baseUrl}`,
};
